import { args, declareEvent } from "@cloudextend/common/events";

import { Notice } from "./notice";

export const notify = declareEvent(
    "#notifications:Notify",
    args<{ notice: Notice }>()
);
